import React, { useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import { ThemeProvider, useTheme } from '@mui/material/styles';
import { CssBaseline, StyledEngineProvider, Snackbar, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import './AxiosConfig'

import Routes from './routes';
import RatingModal from './caller-components/RatingModal';
import themes from './themes';
import Locales from './ui-component/Locales';
import NavigationScroll from './layout/NavigationScroll';
import { JWTProvider } from './contexts/JWTContext';
import axios from 'axios';
import ChatbotComponent from './chatbot/Chatbot';
import useAuth from './hooks/useAuth';

const AuthOnlyChatbot = () => {
    const { isLoggedIn } = useAuth();
    const userData = JSON.parse(localStorage.getItem('userData') || '{}');
    const isDoctor = userData?.role === 'doctor';
    const isTrDoctor = userData?.country === '0';
    return isLoggedIn && isDoctor && isTrDoctor ? <ChatbotComponent /> : null;
};

const App = () => {
    axios.interceptors.request.use(config => {
        // Her istek yapılmadan önce localStorage'dan token alın
        const token = localStorage.getItem('serviceToken');
        console.log("HER İSTEK ATILDI")
        // Eğer token varsa, Authorization header'ına ekleyin
        if (token) {
          config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
      }, error => {
        // İstek hatasıyla ilgili işlemler
        return Promise.reject(error);
      });
    
      // Response Interceptor
      axios.interceptors.response.use(response => {
        // Her şey yolundaysa, response'u döndür
        return response;
      }, error => {
        if (error.response) {
          switch (error.response.status) {
            
            // case 401:
            //   // Kullanıcıyı login sayfasına yönlendir
            //   localStorage.clear();
            //   window.location = '/new/login';
            //   break;

            case 400: 
                break;
            case 500:
              // Kullanıcıyı özel hata sayfasına yönlendir
                window.location = '/new/error-page';
              break;
          }
        }
        
        return Promise.reject(error);
      });
    
    const customization = useSelector((state) => state.customization);
    const theme = useTheme();
    const [open, setOpen] = useState(false);

    const checkZoomLevel = () => {
        const zoomLevel = window.devicePixelRatio * 100;
        const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
    
        if (isMac) {
            // Adjust the zoom level for Mac devices
            if (zoomLevel >= 250) {
                setOpen(true);
            } else {
                setOpen(false);
            }
        } else {
            // For non-Mac devices, consider zoom level of 100
            if (zoomLevel > 100) {
                setOpen(true);
            } else {
                setOpen(false);
            }
        }
    
        // Close the zoom warning after 10 seconds
        setTimeout(() => {
            setOpen(false);
        }, 10000);
    };

    useEffect(() => {
        window.addEventListener('resize', checkZoomLevel);
        checkZoomLevel();
        return () => {
            window.removeEventListener('resize', checkZoomLevel);
        }
    }, []);

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };

    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={themes(customization)}>
                <CssBaseline />
                <Locales>
                    <NavigationScroll>
                        <JWTProvider>
                            <>
                                <Routes />
                                <AuthOnlyChatbot />
                                <RatingModal />
                                <Snackbar
                                    open={open} 
                                    action={
                                        <IconButton
                                            size="small"
                                            aria-label="close"
                                            color="inherit"
                                            onClick={handleClose}
                                        >
                                            <CloseIcon fontSize="small" />
                                        </IconButton>
                                    }
                                    onClose={handleClose}
                                    message="Please Press Ctrl + 0 or Cmd + 0"
                                />
                            </>
                        </JWTProvider>
                    </NavigationScroll>
                </Locales>
            </ThemeProvider>
        </StyledEngineProvider>
    );
};

export default App;